<template>
  <div class=""></div>

  <footer class="bg-light">
    <div class="container">
      <div class="footer-row d-flex flex-wrap">
        <div class="footer-col footer-col--brand">
          <router-link to="/" class="footer-logos__item footer-brand" :aria-label="$t('website')">
            <img src="/img/cp/logo_new.svg" alt="" class="footer-brand__img" />
          </router-link>
        </div>
        <div class="footer-col footer-col--partners footer-logos d-flex flex-wrap">
          <a href="https://www.bhic.sk" target="_blank" rel="noopener noreferrer" class="footer-logos__item">
            <img src="/img/cp/logo_BHI.png" alt="BHI" />
          </a>
          <a href="https://starr.com/Industries/Travel" target="_blank" rel="noopener noreferrer" class="footer-logos__item">
            <img src="/img/cp/Logo%20new%202026-1.svg" alt="Starr" class="footer-logos__starr" />
          </a>
          <span class="footer-logos__item">
            <img src="/img/cp/ec_logo.png" alt="Eurocross" class="footer-logos__eurocross" />
          </span>
        </div>
        <div class="footer-col footer-col--info">
          <router-link to="/files">
            {{ $t('footer.all_info') }}
          </router-link>
        </div>
      </div>

    </div>
  </footer>
  <!-- cookie warning toast -->
  <div v-if="show" class="cookie-toast-wrap fixed-bottom p-4">
    <div class="toast show bg-light w-40 mw-40" role="alert" data-autohide="false">
      <div class="toast-header">

        <strong class="me-auto"></strong>
        <small></small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" @click="save(0)"></button>
      </div>
      <div class="toast-body p-4 d-flex flex-column">
        <h4>{{ $t("cookies.title") }}</h4>
        <p>
          {{ $t("cookies.subtitle") }}
        </p>
        <div class="ml-auto">
<!--          <button type="button" class="btn btn-outline-light mr-3" id="btnDeny">-->
<!--            Deny-->
<!--          </button>-->
          <button type="button" class="btn btn-primary" @click="save(1)">
            {{ $t("cookies.button") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CookieLaw from 'vue-cookie-law'
export default {
  name: "FooterPart",
  components: {

  },
  data: function (){
    return { show: false}
  },
  props: {
    product: String
  },
  methods: {
    save(val){
      localStorage.setItem('cookies', val);
      this.show = false;
    }
  },
  mounted() {
     this.show = !localStorage.getItem('cookies');
  }
}
</script>

<style scoped>
footer{
  border-top: 5px solid var(--main-color);
  /*background-color: var(--main-color);/*/

}
.footer-row{
  gap: 1rem;
  padding: 0.5rem 0;
  justify-content: space-between;
  align-items: center;
}
.footer-col--brand{
  flex: 0 0 auto;
}
.footer-col--partners{
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.footer-col--info{
  flex: 0 0 auto;
  text-align: right;
}
.footer-brand__img{
  height: 60px;
  width: auto;
  max-width: min(280px, 40vw);
}
.footer-logos{
  align-items: center;
}
.footer-logos__item{
  display: inline-flex;
  align-items: center;
  margin: 16px 12px;
  line-height: 0;
}
.footer-logos__item img{
  display: block;
  max-height: 60px;
  width: auto;
  mix-blend-mode: darken;
  pointer-events: none;
}
.footer-logos__item img.footer-logos__starr{
  max-height: 50px;
  mix-blend-mode: normal;
}
@media (max-width: 767.98px) {
  .footer-row{
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .footer-col{
    width: 100%;
    align-self: flex-start;
  }
  .footer-col--partners{
    justify-content: flex-start;
    align-items: center;
    align-content: center;
  }
  .footer-col--info{
    text-align: left;
  }
  .footer-logos{
    align-items: center;
  }
  .footer-logos__item{
    margin: 12px 12px 12px 0;
  }
  .footer-logos__item img{
    max-height: 50px;
  }
  .footer-logos__item img.footer-logos__starr{
    max-height: 40px;
  }
}
.footer-logos__eurocross{
  mix-blend-mode: normal;
}
a{
  text-decoration: none;
  color: var(--main-color);
}
</style>